import { AppLanguage } from './language';
import { generatedTranslations } from './generatedTranslations';
import { translateUiText } from './runtimeTranslations';

const baseTranslations = {
  ru: {
    app: {
      browserTitle: 'КиберФит: Альманах',
    },
    common: {
      language: 'Язык',
      russian: 'Русский',
      english: 'English',
      close: 'Закрыть',
      menu: 'Меню',
      logout: 'Выйти',
      level: 'Уровень',
    },
    landing: {
      logoTitle: 'КИБЕРФИТ',
      logoText: 'EST. 2025 | революция на стыке геймификации и фитнеса',
      main: 'Главная',
      about: 'О проекте',
      modules: 'Модули',
      world: 'Мир',
      contacts: 'Контакты',
    },
    menu: {
      profile: 'Профиль',
      characters: 'Персонажи',
      nutritionAnalysis: 'Анализ питания',
      metabolism: 'Метаболизм',
      psychology: 'Психика',
      heartRate: 'Сердечный ритм',
      breathingAssessment: 'Оценка дыхания',
      userParameters: 'Параметры пользователя',
      functional: 'Функциональные тренировки',
      running: 'Беговые тренировки',
      short: 'Короткие тренировки',
      cognitive: 'Когнитивные тренировки',
      fineMotor: 'Хиральные Арканы',
      immersive: 'Имерсивные тренировки',
      bos: 'БОС тренировки',
      breathing: 'Дыхательные тренировки',
    },
    personalAccount: {
      guide: {
        title: 'Профиль проводника',
        realIdentity: 'Проводник — это ваша реальная личность и привычки',
        heroProjection: 'Персонаж — это ваша проекция в игровом мире',
        hallTitle: 'Зал славы',
        hallText: 'Здесь всё о вас как об уникальной биосистеме: данные о питании и метаболизме для лучшего понимания себя',
        chronicleTitle: 'Летопись героя',
        chronicleText: 'Здесь всё о виртуальной личности: её достижения, прогресс и история в рамках игрового мира',
      },
      modules: {
        provisionsTitle: 'Провизии',
        provisionsText1: 'Сбалансированный рацион — основа сил героя. Следите за балансом КБЖУ.',
        provisionsText2: 'Посмотрите КБЖУ за период и проанализируйте вплоть до приёма пищи.',
        metabolismTitle: 'Анализ метаболизма',
        metabolismText: 'Чтобы открыть точный расчёт метаболизма, профиль героя должен быть заполнен на 100%. Система должна знать о вас всё, чтобы дать самый точный совет.',
        psychologyTitle: 'Психологический профиль',
        psychologyText: 'Психологический цифровой двойник объединяет результаты тестов, готовность и физиологический контекст, чтобы показать динамику внутреннего ресурса.',
        heartRateTitle: 'Сердечный ритм',
        heartRateText: 'Динамика BPM, пульсовые зоны, качество сигнала и восстановление по функциональным, беговым и коротким тренировкам.',
        heartRateAction: 'Открыть',
        breathingAssessmentTitle: 'Оценка дыхательной деятельности',
        breathingAssessmentText: 'Спирометрия, дыхательный ритм, переносимость нагрузки и восстановление в отдельном функциональном профиле.',
        breathingAssessmentAction: 'Открыть',
        userParametersTitle: 'Параметры пользователя',
        userParametersText: 'Рост, масса тела, состав тела, анализы и масса медбола для персонализации цифровых двойников и тренировочных расчётов.',
        userParametersAction: 'Открыть',
        runningTitle: 'Беговая активность',
        runningText: 'Исследуйте реальный город, чтобы открыть тайны виртуального мира. Каждая пробежка отмечает новые локации на карте и даёт персонажу уникальные бонусы.',
        muscleTitle: 'Мышечная активность',
        muscleText: 'Превратите энергию своих мышц в силу удара для героя. 3D-модель покажет, какие группы мышц дают игровые преимущества прямо сейчас.',
        cognitiveTitle: 'Когнитивные тренировки',
        cognitiveText: 'Каждая решённая головоломка и упражнение на память заряжают героя интеллектуальной энергией.',
        check: 'Проверить',
        view: 'Посмотреть',
      },
    },
  },
  en: {
    app: {
      browserTitle: 'CyberFit: Almanac',
    },
    common: {
      language: 'Language',
      russian: 'Русский',
      english: 'English',
      close: 'Close',
      menu: 'Menu',
      logout: 'Log out',
      level: 'Level',
    },
    landing: {
      logoTitle: 'CYBERFIT',
      logoText: 'EST. 2025 | fitness gamification revolution',
      main: 'Home',
      about: 'About',
      modules: 'Modules',
      world: 'World',
      contacts: 'Contacts',
    },
    menu: {
      profile: 'Profile',
      characters: 'Characters',
      nutritionAnalysis: 'Nutrition analysis',
      metabolism: 'Metabolism',
      psychology: 'Psychology',
      heartRate: 'Heart rate',
      breathingAssessment: 'Breathing assessment',
      userParameters: 'User parameters',
      functional: 'Functional training',
      running: 'Running training',
      short: 'Short workouts',
      cognitive: 'Cognitive training',
      fineMotor: 'Chiral Arcana',
      immersive: 'Immersive training',
      bos: 'Biofeedback training',
      breathing: 'Breathing training',
    },
    personalAccount: {
      guide: {
        title: 'Guide profile',
        realIdentity: 'The guide is your real identity and habits',
        heroProjection: 'The character is your projection in the game world',
        hallTitle: 'Hall of Fame',
        hallText: 'Everything about you as a unique biosystem: nutrition and metabolism data for better self-understanding',
        chronicleTitle: 'Hero Chronicle',
        chronicleText: 'Everything about your virtual identity: achievements, progress, and story inside the game world',
      },
      modules: {
        provisionsTitle: 'Provisions',
        provisionsText1: 'A balanced diet is the foundation of your hero’s strength. Track the protein, fat, carbohydrate, and calorie balance.',
        provisionsText2: 'Review nutrition for a selected period and analyze it down to each meal.',
        metabolismTitle: 'Metabolism Analysis',
        metabolismText: 'To unlock an accurate metabolism calculation, your hero profile must be 100% complete. The system needs the full picture to give the most precise advice.',
        psychologyTitle: 'Psychological Profile',
        psychologyText: 'The psychological digital twin combines assessment results, readiness, and physiological context to show changes in your inner resources.',
        heartRateTitle: 'Heart rate',
        heartRateText: 'BPM dynamics, training zones, signal quality, and recovery across functional, running, and short workouts.',
        heartRateAction: 'Open',
        breathingAssessmentTitle: 'Breathing assessment',
        breathingAssessmentText: 'Spirometry, breathing rhythm, exercise tolerance, and recovery in a dedicated functional profile.',
        breathingAssessmentAction: 'Open',
        userParametersTitle: 'User Parameters',
        userParametersText: 'Height, body weight, body composition, lab markers, and medicine ball mass for personalized digital twins and training calculations.',
        userParametersAction: 'Open',
        runningTitle: 'Running Activity',
        runningText: 'Explore the real city to uncover the secrets of the virtual world. Each run marks new map locations and gives your character unique bonuses.',
        muscleTitle: 'Muscle Activity',
        muscleText: 'Turn muscle energy into strike power for your hero. The 3D model shows which muscle groups provide game advantages right now.',
        cognitiveTitle: 'Cognitive Training',
        cognitiveText: 'Each solved puzzle and memory exercise charges your hero with intellectual energy.',
        check: 'Check',
        view: 'View',
      },
    },
  },
} as const;

export const translations = {
  ru: {
    ...baseTranslations.ru,
    ...generatedTranslations.ru,
  },
  en: {
    ...baseTranslations.en,
    ...generatedTranslations.en,
  },
} as const;

type Dictionary = typeof translations.ru;
type DotPrefix<T extends string> = T extends '' ? '' : `.${T}`;
type DotNestedKeys<T> = (
  T extends object
    ? { [K in Extract<keyof T, string>]: `${K}${DotPrefix<DotNestedKeys<T[K]>>}` }[Extract<keyof T, string>]
    : ''
) extends infer D
  ? Extract<D, string>
  : never;

export type TranslationKey = DotNestedKeys<Dictionary>;

export const translate = (language: AppLanguage, key: TranslationKey): string => {
  const parts = key.split('.');
  let current: any = translations[language];

  for (const part of parts) {
    current = current?.[part];
  }

  if (typeof current === 'string') return translateUiText(current, language);

  current = translations.ru;
  for (const part of parts) {
    current = current?.[part];
  }

  return typeof current === 'string' ? translateUiText(current, language) : key;
};
